import { BlueCircleTriangleCutoutConfig } from 'libs/end-to-end/src/dimension';
import { BlueRoundedTriangleConfig } from 'libs/end-to-end/src/dimension';
import { LevelDefinition } from 'libs/end-to-end/src/types/databases/dimensions/level-definition';
import { DimensionConfigIcon } from 'libs/end-to-end/src/dimension';
import { GenderFemaleIconConfig } from 'libs/end-to-end/src/dimension';
import { GenderMaleIconConfig } from 'libs/end-to-end/src/dimension';
import { GenderOtherIconConfig } from 'libs/end-to-end/src/dimension';
import { GreenCircleOutlineConfig } from 'libs/end-to-end/src/dimension';
import { GreenTriangleTriangleCutoutConfig } from 'libs/end-to-end/src/dimension';
import { GreyTriangleCircleCutoutConfig } from 'libs/end-to-end/src/dimension';
import { OrangeDiamondCircleCutoutConfig } from 'libs/end-to-end/src/dimension';
import { PurpleCircleConfig } from 'libs/end-to-end/src/dimension';
import React from 'react';
import { ConfigColors } from 'libs/end-to-end/src/types/branding/colors';
import { BlueRoundedTriangleGroup } from 'apps/sigma2-ui/src/components/svg/BlueRoundedTriangle';
import { BlueRoundedTriangleSvg } from 'apps/sigma2-ui/src/components/svg/BlueRoundedTriangle';
import { PurpleCircleGroup } from 'apps/sigma2-ui/src/components/svg/PurpleCircle';
import { PurpleCircleSvg } from 'apps/sigma2-ui/src/components/svg/PurpleCircle';
import { GreenCircleOutlineGroup } from 'apps/sigma2-ui/src/components/svg/GreenCircleOutline';
import { GreenCircleOutlineSvg } from 'apps/sigma2-ui/src/components/svg/GreenCircleOutline';
import { SvgCenterProps } from 'apps/sigma2-ui/src/components/svg/types';
import { SvgProps } from 'apps/sigma2-ui/src/components/svg/types';
import { LevelDefinitionIconProps } from 'apps/sigma2-ui/src/components/level-definition-icon-props';
import { toSvgColor } from 'apps/sigma2-ui/src/components/svg/types';
import { SvgGroupCenter } from 'apps/sigma2-ui/src/components/svg/SvgGroupCenter';

type AdditionalProps = {
  levelDefinition: LevelDefinition;
  focused: boolean;
  dimmed?: boolean;
};

export const LevelDefinitionIconGroup: React.FC<
  LevelDefinitionIconProps & AdditionalProps
> = (props) => {
  const { levelDefinition, focused, dimmed } = props;

  const map: Record<
    DimensionConfigIcon,
    React.FC<SvgProps & SvgCenterProps>
  > = {
    [BlueRoundedTriangleConfig]: BlueRoundedTriangleGroup,
    [PurpleCircleConfig]: PurpleCircleGroup,
    [GreenCircleOutlineConfig]: GreenCircleOutlineGroup,
    [GreyTriangleCircleCutoutConfig]: GreyTriangleCircleCutoutGroup,
    [GreenTriangleTriangleCutoutConfig]: GreenTriangleTriangleCutoutGroup,
    [BlueCircleTriangleCutoutConfig]: BlueCircleTriangleCutoutGroup,
    [OrangeDiamondCircleCutoutConfig]: OrangeDiamondCircleCutoutGroup,
    [GenderMaleIconConfig]: GenderMaleIconGroup,
    [GenderFemaleIconConfig]: GenderFemaleIconGroup,
    [GenderOtherIconConfig]: GenderOtherIconGroup,
  };

  const color = dimmed
    ? `${ConfigColors[levelDefinition.color].Primary.raw}60`
    : ConfigColors[levelDefinition.color].Primary.raw;
  return (
    <>
      {map[levelDefinition.icon]({
        ...props,
        wantsColor: focused ? 'white' : color,
      })}
    </>
  );
};

export const LevelDefinitionIcon: React.FC<
  LevelDefinitionIconProps &
    AdditionalProps & {
      additionalClasses?: string;
    }
> = (props) => {
  const { levelDefinition, focused, additionalClasses } = props;

  const map: Record<DimensionConfigIcon, React.FC<SvgProps>> = {
    [BlueRoundedTriangleConfig]: BlueRoundedTriangleSvg,
    [PurpleCircleConfig]: PurpleCircleSvg,
    [GreenCircleOutlineConfig]: GreenCircleOutlineSvg,
    [GreyTriangleCircleCutoutConfig]: GreyTriangleCircleCutoutSvg,
    [GreenTriangleTriangleCutoutConfig]: GreenTriangleTriangleCutoutSvg,
    [BlueCircleTriangleCutoutConfig]: BlueCircleTriangleCutoutSvg,
    [OrangeDiamondCircleCutoutConfig]: OrangeDiamondCircleCutoutSvg,
    [GenderMaleIconConfig]: GenderMaleIconSvg,
    [GenderFemaleIconConfig]: GenderFemaleIconSvg,
    [GenderOtherIconConfig]: GenderOtherIconSvg,
  };

  return (
    <>
      {map[levelDefinition.icon]({
        ...props,
        svg: { className: additionalClasses },
        wantsColor: focused
          ? 'white'
          : ConfigColors[levelDefinition.color].Primary.raw,
      })}
    </>
  );
};

export const GreyTriangleCircleCutoutGroup: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  const fillColor = toSvgColor('#858585', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={10} baseHeight={10} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.9535 0.72818L0.189923 7.62808C-0.173554 8.29445 0.30876 9.10693 1.06782 9.10693H8.59498C9.35404 9.10693 9.83635 8.29445 9.47287 7.62808L5.70929 0.728178C5.33028 0.0333144 4.33252 0.0333162 3.9535 0.72818ZM4.83125 7.1787C5.58347 7.1787 6.19328 6.5689 6.19328 5.81667C6.19328 5.06444 5.58347 4.45464 4.83125 4.45464C4.07902 4.45464 3.46921 5.06444 3.46921 5.81667C3.46921 6.5689 4.07902 7.1787 4.83125 7.1787Z"
          fill={fillColor}
        />
      </SvgGroupCenter>
    </g>
  );
};

export const GreyTriangleCircleCutoutSvg: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GreyTriangleCircleCutoutGroup {...props} />
    </svg>
  );
};

export const GreenTriangleTriangleCutoutGroup: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  const strokeColor = toSvgColor('#2C800F', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={11} baseHeight={12} {...props}>
        <path
          d="M1.61803 10.1074L5.5 2.34349L9.38197 10.1074H1.61803Z"
          stroke={strokeColor}
          strokeWidth="2"
        />
      </SvgGroupCenter>
    </g>
  );
};

export const GreenTriangleTriangleCutoutSvg: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GreenTriangleTriangleCutoutGroup {...props} />
    </svg>
  );
};

export const BlueCircleTriangleCutoutGroup: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  const fillColor = toSvgColor('#076DD3', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={11} baseHeight={12} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.5 11.1074C8.53757 11.1074 11 8.64499 11 5.60742C11 2.56986 8.53757 0.107422 5.5 0.107422C2.46243 0.107422 0 2.56986 0 5.60742C0 8.64499 2.46243 11.1074 5.5 11.1074ZM4.6221 3.2169L2.80665 6.54524C2.44317 7.21161 2.92548 8.02409 3.68454 8.02409H7.31546C8.07452 8.02409 8.55683 7.21161 8.19335 6.54524L6.3779 3.2169C5.99888 2.52203 5.00112 2.52203 4.6221 3.2169Z"
          fill={fillColor}
        />
      </SvgGroupCenter>
    </g>
  );
};

export const BlueCircleTriangleCutoutSvg: React.FC<LevelDefinitionIconProps> = (
  props,
) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <BlueCircleTriangleCutoutGroup {...props} />
    </svg>
  );
};

export const OrangeDiamondCircleCutoutGroup: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  const fillColor = toSvgColor('#FB8C3C', props);

  return (
    <g fill="none" {...(props.group ?? {})}>
      <SvgGroupCenter baseWidth={11} baseHeight={12} {...props}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.01025 4.0976C6.14835 3.2357 4.75093 3.2357 3.88903 4.0976C3.02713 4.9595 3.02713 6.35691 3.88903 7.21881C4.75093 8.08071 6.14835 8.08071 7.01025 7.21881C7.87215 6.35691 7.87215 4.9595 7.01025 4.0976ZM0.914214 4.24399C0.133165 5.02504 0.133165 6.29137 0.914214 7.07242L4.03543 10.1936C4.81648 10.9747 6.08281 10.9747 6.86385 10.1936L9.98507 7.07242C10.7661 6.29137 10.7661 5.02504 9.98507 4.24399L6.86385 1.12278C6.08281 0.341728 4.81648 0.341728 4.03543 1.12278L0.914214 4.24399Z"
          fill={fillColor}
        />
      </SvgGroupCenter>
    </g>
  );
};

export const OrangeDiamondCircleCutoutSvg: React.FC<
  LevelDefinitionIconProps
> = (props) => {
  return (
    <svg
      width="11"
      height="12"
      viewBox="0 0 11 12"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <OrangeDiamondCircleCutoutGroup {...props} />
    </svg>
  );
};

export const GenderMaleIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <g clipPath="url(#clip0_1723_9922)">
        <path
          d="M6.11914 4.88488L9.94914 1.04688"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.92146 4.88513C2.33669 4.46993 2.86572 4.18719 3.44164 4.07265C4.01756 3.95812 4.61451 4.01693 5.15701 4.24166C5.69951 4.46638 6.16319 4.84692 6.48941 5.33517C6.81564 5.82341 6.98976 6.39743 6.98976 6.98463C6.98976 7.57183 6.81564 8.14584 6.48941 8.63409C6.16319 9.12233 5.69951 9.50287 5.15701 9.7276C4.61451 9.95232 4.01756 10.0111 3.44164 9.8966C2.86572 9.78206 2.33669 9.49932 1.92146 9.08413C1.64573 8.80843 1.42701 8.48111 1.27779 8.12088C1.12856 7.76064 1.05176 7.37454 1.05176 6.98463C1.05176 6.59471 1.12856 6.20861 1.27779 5.84837C1.42701 5.48814 1.64573 5.16083 1.92146 4.88513Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.27734 1.04688H9.94934V3.71888"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_9922">
          <rect width="11" height="11" fill="white" />
        </clipPath>
      </defs>
    </g>
  );
};

export const GenderMaleIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GenderMaleIconGroup {...props} />
    </svg>
  );
};

export const GenderFemaleIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <g clipPath="url(#clip0_1723_9945)">
        <path
          d="M5.5 7.4375V10.4065"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.31348 9.21875H6.68848"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.53125 4.469C2.53125 5.25643 2.84405 6.0116 3.40085 6.5684C3.95765 7.1252 4.71282 7.438 5.50025 7.438C6.28768 7.438 7.04285 7.1252 7.59965 6.5684C8.15645 6.0116 8.46925 5.25643 8.46925 4.469C8.46925 3.68157 8.15645 2.9264 7.59965 2.3696C7.04285 1.8128 6.28768 1.5 5.50025 1.5C4.71282 1.5 3.95765 1.8128 3.40085 2.3696C2.84405 2.9264 2.53125 3.68157 2.53125 4.469Z"
          stroke={strokeColor}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1723_9945">
          <rect
            width="11"
            height="11"
            fill="white"
            transform="translate(0 0.453125)"
          />
        </clipPath>
      </defs>
    </g>
  );
};

export const GenderFemaleIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GenderFemaleIconGroup {...props} />
    </svg>
  );
};

export const GenderOtherIconGroup: React.FC<SvgProps> = (props) => {
  const strokeColor = toSvgColor('currentColor', props);
  return (
    <g fill="none" {...(props.group ?? {})}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.01025 3.99017C6.14835 3.12828 4.75093 3.12828 3.88903 3.99017C3.02713 4.85207 3.02713 6.24949 3.88903 7.11139C4.75093 7.97329 6.14835 7.97329 7.01025 7.11139C7.87215 6.24949 7.87215 4.85207 7.01025 3.99017ZM0.914214 4.13657C0.133165 4.91762 0.133165 6.18395 0.914214 6.96499L4.03543 10.0862C4.81648 10.8673 6.08281 10.8673 6.86385 10.0862L9.98507 6.96499C10.7661 6.18395 10.7661 4.91762 9.98507 4.13657L6.86385 1.01535C6.08281 0.234306 4.81648 0.234306 4.03543 1.01535L0.914214 4.13657Z"
        fill={strokeColor}
      />
    </g>
  );
};

export const GenderOtherIconSvg: React.FC<SvgProps> = (props) => {
  return (
    <svg
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...(props.svg ?? {})}
    >
      <GenderOtherIconGroup {...props} />
    </svg>
  );
};
